<template>
  <div @click="selectShop" class="shops-filter-shop-card">
    <address class="shops-filter-shop-card__title">{{ shopData.city }}, {{ shopData.description_ru }}</address>
    <span class="shops-filter-shop-card__status" :style="{'color': shopData.scheduleObj.label.color}">{{ $t(`${shopData.scheduleObj.label.translationKey}`) }}</span>
    <div class="shops-filter-shop-card__schedule-wrap">
      <span class="shops-filter-shop-card__schedule" v-if="shopData.scheduleObj.schedule" v-html="shopData.scheduleObj.schedule"></span>
      <span class="shops-filter-shop-card__phone" v-if="shopData.phone" v-html="shopData.phone"></span>
    </div>
    <a v-if="isShowRouteBtn"
       :href="routeHref"
       @click.stop
       target="_blank"
       class="shops-filter-shop-card__route-btn">
      <svg width="16"
           height="16"
           viewBox="0 0 16 16"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M15.7622 7.43399L8.56218 0.234C8.25018 -0.0779999 7.74216 -0.0779999 7.43418 0.234L0.234183 7.43399C-0.0778168 7.74599 -0.0778168 8.25401 0.234183 8.56601L7.43418 15.762V15.766C7.74618 16.078 8.25419 16.078 8.56619 15.766L15.7662 8.56601C16.0781 8.24999 16.0781 7.74599 15.7622 7.43399ZM9.59815 9.99798V7.99799H6.39816V10.398H4.79815V7.19801C4.79815 6.75401 5.15414 6.39802 5.59814 6.39802H9.59815V4.398L12.3982 7.19801L9.59815 9.99798Z" fill="rgba(51, 51, 51, 0.7)"/>
      </svg>
      {{ $t('site.shops.bulid.route') }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'ShopsFilterShopCard',
  props: {
    shopData: {
      type: Object,
      required: true
    }
  },
  computed: {
    isShowRouteBtn () {
      return this.shopData.googleLink || (this.shopData.longitude && this.shopData.latitude)
    },
    routeHref () {
      if (this.isShowRouteBtn) {
        return this.shopData.googleLink || `//maps.google.com/maps?saddr=&daddr=${this.shopData.latitude}, ${this.shopData.longitude}`
      }

      return ''
    }
  },
  methods: {
    selectShop () {
      this.$emit('select-shop', this.shopData)
    }
  }
}
</script>

<style scoped lang="sass">

.shops-filter-shop-card
  padding: 20px 25px
  cursor: pointer

.shops-filter-shop-card__title
  display: block
  font-size: 14px
  font-weight: 500
  font-style: normal
  margin-bottom: 15px

.shops-filter-shop-card__status
  display: block
  font-size: 14px
  font-weight: 500
  margin-bottom: 10px

.shops-filter-shop-card__schedule-wrap
  width: 100%
  display: flex
  flex-flow: row wrap
  justify-content: space-between

.shops-filter-shop-card__schedule,
.shops-filter-shop-card__phone
  position: relative
  width: 49%
  min-width: 160px
  font-size: 14px
  color: $placeholder-color
  padding-left: 25px
  margin-bottom: 20px

  &:before
    position: absolute
    top: 0
    left: 0
    content: ''
    display: block
    width: 12px
    height: 12px

.shops-filter-shop-card__schedule:before
  content: url(/img/svgo/shop-schedule.svg)

.shops-filter-shop-card__phone:before
  content: url(/img/svgo/telephone.svg)

.shops-filter-shop-card__route-btn
  display: flex
  justify-content: center
  width: 100%
  font-size: 14px
  font-weight: 500
  color: $white-text-color
  padding: 11px 20px
  border: none
  border-radius: 3px
  background: $main-color
  transition: .2s

  &:hover
    background: $main-color--hover

  svg
    margin-right: 15px

    path
      fill: $white-text-color
</style>
